export class AisGenericResponseDto {
  success: boolean
  errorMessage?: string
}